import * as React from 'react';

import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';

import { Utils } from './classi/Utils.js';

export class LogoutConfirm extends React.Component {

    constructor() {
        super()
        this.state = {
            hideDialog : false
        };

        this.utils = new Utils();

        this.closeDialog = this.closeDialog.bind(this);
        this.logout = this.logout.bind(this);
    }

    closeDialog = () => {
        this.setState({ hideDialog:true });
    };

    logout = () => {
        this.utils.logout();
    };

    render(){
        return (
            <Dialog
                hidden={this.state.hideDialog}
                onDismiss={this.closeDialog}
                dialogContentProps={{ type: DialogType.largeHeader , title: "Confermare Uscita", subText: "Vuoi davvero uscire?" }}
                modalProps={{ isBlocking: true, className: 'ms-dialogMainOverride dialogPopup' }}
            >
                <DialogFooter>
                    <DefaultButton onClick={this.closeDialog} text="Annulla" />
                    <PrimaryButton onClick={this.logout} text="Si" />
                </DialogFooter>
            </Dialog>
        );
    }
}

export default LogoutConfirm;


// WEBPACK FOOTER //
// ./src/AcComponents/LogoutConfirm.js